<template>
  <div id="subpage" v-loading="loading">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <b>房车管理</b>
        </el-breadcrumb-item>
        <el-breadcrumb-item to="/car_house/configure">车型配置列表</el-breadcrumb-item>
        <el-breadcrumb-item>添加车型配置</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <div class="content">
      <div class="xcx-head">
        <span class="title">添加车型配置</span>
        <span class="xcx-add left font14" @click="reback()">返回列表</span>
      </div>
      <div class="xcx-content">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm" style="width: 50%">
          <el-form-item label="品牌：" prop="brand">
            <el-col :span="20">
              <el-select v-model="ruleForm.brand_id" placeholder="请选择品牌">
                <el-option label="请选择" :value="0"></el-option>
                <el-option v-for="item in brand" :key="item.id" :label="item.title" :value="item.id"></el-option>
              </el-select>
            </el-col>
          </el-form-item>
          <el-form-item label="车型：" prop="model">
            <el-col :span="20">
              <el-input placeholder="请填写车型" v-model="ruleForm.model"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="中控：" prop="control">
            <el-col :span="20">
              <el-input placeholder="请填中控" v-model="ruleForm.control"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="底盘：" prop="chassis">
            <el-col :span="20">
              <el-input placeholder="请填底盘" v-model="ruleForm.chassis"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="发动机型号：" prop="engine">
            <el-col :span="20">
              <el-input placeholder="请填发动机型号" v-model="ruleForm.engine"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="锂电：" prop="lithium">
            <el-col :span="20">
              <el-input placeholder="请填锂电" v-model="ruleForm.lithium"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="光伏：" prop="photovoltaic">
            <el-col :span="20">
              <el-input placeholder="请填光伏" v-model="ruleForm.photovoltaic"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="水箱：" prop="water">
            <el-col :span="20">
              <el-input placeholder="请填水箱" v-model="ruleForm.water"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="空调：" prop="conditioner">
            <el-col :span="20">
              <el-input placeholder="请填空调" v-model="ruleForm.conditioner"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="热水器：" prop="heater">
            <el-col :span="20">
              <el-input placeholder="请填热水器" v-model="ruleForm.heater"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="电视：" prop="television">
            <el-col :span="20">
              <el-input placeholder="请填电视" v-model="ruleForm.television"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="净水机：" prop="purifier">
            <el-col :span="20">
              <el-input placeholder="请填热水器" v-model="ruleForm.purifier"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="生产日期：" prop="stime">
            <el-col :span="20">
              <el-date-picker value-format="yyyy-MM-dd" v-model="ruleForm.stime" type="date" placeholder="请填生产日期">
              </el-date-picker>
            </el-col>
          </el-form-item>
          <el-form-item>
            <div style="width: 100%; height: 15px"></div>
            <el-button type="primary" @click="submitForm('ruleForm')" v-if="id">确认修改</el-button>
            <el-button type="primary" @click="submitForm('ruleForm')" v-else>确认添加</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: true,
      id: "",
      brand: [],
      ruleForm: {
        brand_id: "",
        model: "",
        control: "",
        chassis: "",
        engine: "",
        lithium: "",
        photovoltaic: "",
        water: "",
        conditioner: "",
        heater: "",
        television: "",
        purifier: "",
        stime: "",
      },
      rules: {
        brand: [{ required: true, message: "请输入", trigger: "blur" }],
        model: [{ required: true, message: "请输入", trigger: "blur" }],
        control: [{ required: true, message: "请输入", trigger: "blur" }],
      },
    };
  },

  /**
   * 进入页面加载
   */
  mounted() {
    var that = this;
    var query = that.$route.query;
    if (query.id) {
      that.id = query.id;
      that.getDetail();
    }
    that.getCate();
    that.loading = false;
  },
  methods: {
    getCate() {
      var that = this;
      that.axios.post("/car_brand/getCate").then((res) => {
        if (res) {
          that.brand = res.data;
        }
      });
    },
    /**
     * 获取详情
     */
    getDetail() {
      var that = this;
      that.axios.post("/car_house/edit", { id: that.id }).then((res) => {
        if (res) {
          that.ruleForm = res.data;
        }
      });
    },
    submitForm(formName) {
      const that = this;
      that.$refs[formName].validate((valid) => {
        if (!valid) return that.$message.warning("请完整填写内容!");
        var formData = {};
        formData = that.ruleForm;
        var url = "/car_house/store";
        if (that.id) {
          formData.id = that.id;
          url = "/car_house/update";
        }
        that.axios.post(url, formData).then(() => {
          that.$message.success(that.id ? "修改成功" : "添加成功");
          that.$router.push("/car_house/configure");
        });
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    /**
     * 返回
     */
    reback() {
      this.$router.push("/car_house/configure");
    },
  },
};
</script>
<style>
.line {
  text-align: center;
}

.banner_img .updata_img .el-upload.el-upload--picture-card {
  width: 148px;
  height: 148px;
  line-height: 148px;
}

.quill-editor.quill-editor {
  width: 100%;
}

.ql-container.ql-snow {
  width: 100%;
}

.ql-toolbar.ql-snow {
  width: 100%;
}

.ql-container.ql-snow {
  height: 300px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}

.avatar {
  width: 120px;
  height: 120px;
  display: block;
}
</style>